import { render, staticRenderFns } from "./SafeInvite.vue?vue&type=template&id=e46654a8&scoped=true&"
import script from "./SafeInvite.vue?vue&type=script&lang=js&"
export * from "./SafeInvite.vue?vue&type=script&lang=js&"
import style0 from "./SafeInvite.vue?vue&type=style&index=0&id=e46654a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46654a8",
  null
  
)

export default component.exports